export const toBlob = (data: Uint8Array | ArrayBufferLike, fileType: string) => {
  return new Blob([data] as BlobPart[], { type: fileType });
};
